export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'icechopsNo',
    title: '冰排编号',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'icechopsLength',
    title: '冰排长度',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'icechopsWidth',
    align: 'center',
    minWidth: 120,
    title: '冰排宽度',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'icechopsHeight',
    align: 'center',
    minWidth: 120,
    title: '冰排高度',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'tempTypeRange',
    align: 'left',
    minWidth: 120,
    title: '温度范围',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
];
